<template>
  <card-item card="item_business" :tabs="tabs" :activeTab="activeTab" :id="id" :infoKeys="infoKeys"/>
</template>
<script>
export default {
  methods: {
  },
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "Информация", key:'information_card',
          component: () => import("./Info"),
        },
        {
          key:'available_discipline',
          title: "Доступные предметы",
          component: () => import("./BusinessDiscipline"),
        },
      ],
      activeTab: 0,
           infoKeys:[
        {
          key: 'title',
          title:'Школа'
        },]
    };
  },
};
</script>